export class WebSocketClient {
  constructor(url, options = {}) {
    this.url = url
    this.reconnectDelay = options.reconnectDelay || 3000 // 重连间隔
    this.heartbeatInterval = options.heartbeatInterval || 30000 // 心跳间隔
    this.enableHeartbeat = options.enableHeartbeat ?? true // 是否启用心跳
    this.manualClose = false // 标记手动关闭
    this.ws = null
    this.heartbeatTimer = null
    this.reconnectTimer = null

    this.onOpen = options.onOpen || (() => {})
    this.onMessage = options.onMessage || (() => {})
    this.onClose = options.onClose || (() => {})
    this.onError = options.onError || (() => {})
  }

  /** 启动连接 */
  connect() {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) return
    this.manualClose = false

    this.ws = new WebSocket(this.url)

    this.ws.onopen = () => {
      console.log('[WebSocket] Connected:', this.url)
      this.onOpen()
      this.startHeartbeat()
    }

    this.ws.onmessage = event => {
      const data = this.safeParse(event.data)
      if (data && data.type === 'pong') {
        // 收到心跳回应
        return
      }
      this.onMessage(data, event.data)
    }

    this.ws.onclose = () => {
      console.warn('[WebSocket] Disconnected')
      this.stopHeartbeat()
      this.onClose()
      if (!this.manualClose) this.scheduleReconnect()
    }

    this.ws.onerror = err => {
      console.error('[WebSocket] Error:', err)
      this.onError(err)
      this.ws.close() // 触发重连
    }
  }

  /** 手动关闭连接 */
  close() {
    this.manualClose = true
    this.stopHeartbeat()
    if (this.ws) this.ws.close()
  }

  /** 发送消息 */
  send(data) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn('[WebSocket] Not connected, message dropped')
      return
    }
    const msg = typeof data === 'string' ? data : JSON.stringify(data)
    this.ws.send(msg)
  }

  /** 定时发送心跳 */
  startHeartbeat() {
    if (!this.enableHeartbeat) return
    this.stopHeartbeat()
    this.heartbeatTimer = setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify({ type: 'ping', time: Date.now() }))
      }
    }, this.heartbeatInterval)
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) clearInterval(this.heartbeatTimer)
    this.heartbeatTimer = null
  }

  scheduleReconnect() {
    if (this.reconnectTimer) return
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null
      console.log('[WebSocket] Reconnecting...')
      this.connect()
    }, this.reconnectDelay)
  }

  safeParse(data) {
    try {
      return JSON.parse(data)
    } catch {
      return data
    }
  }
}
